import React from 'react'

import { getQuickAccessMode, getQuickAccessModeColor, getQuickAccessModeIcon } from '../utils/machines'

class MachineQuickAccessBadge extends React.Component {
  render() {
    return (
      <div className="badge"
           style={{backgroundColor: getQuickAccessModeColor(this.props.machine)}}>
        <i className={`${getQuickAccessModeIcon(this.props.machine)} mr-1`}></i>
        { getQuickAccessMode(this.props.machine) }
      </div>
    )
  }
}

export default MachineQuickAccessBadge
